import getReportsByDates from "./getRangeReports";
import postBatchTransactions from "./postBatchTransactions";
import postCsv from "./postCsv";
import postReport from "./postReport";

export default {
  getReportsByDates,
  postBatchTransactions,
  postCsv,
  postReport
}